import React from 'react';
import './WeatherTerrain.css';

const WeatherTerrain = () => {
  return (
    <div className="weather-terrain">
      <div className="weather-terrain__header">
        <h1>Weather & Terrain Effects Guide</h1>
        <p>Understanding weather and terrain effects is crucial for competitive battling. These field conditions can dramatically change the flow of battle.</p>
      </div>

      <div className="weather-terrain__content">
        <section className="weather-terrain__section">
          <h2>Weather Effects</h2>
          
          <div className="weather-terrain__grid">
            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Sun/Harsh Sunlight</h3>
              </div>
              <ul>
                <li>Boosts Fire-type moves by 50%</li>
                <li>Weakens Water-type moves by 50%</li>
                <li>Solar Beam/Solar Blade require no charge turn</li>
                <li>Common setters: Drought (Groudon, Torkoal, Ninetales)</li>
                <li>Duration: 5 turns (8 with Heat Rock)</li>
              </ul>
            </div>

            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Rain</h3>
              </div>
              <ul>
                <li>Boosts Water-type moves by 50%</li>
                <li>Weakens Fire-type moves by 50%</li>
                <li>Thunder has 100% accuracy</li>
                <li>Common setters: Drizzle (Kyogre, Pelipper, Politoed)</li>
                <li>Duration: 5 turns (8 with Damp Rock)</li>
              </ul>
            </div>

            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Sandstorm</h3>
              </div>
              <ul>
                <li>Rock-types gain 50% Special Defense</li>
                <li>Damages non-Rock/Ground/Steel types</li>
                <li>Common setters: Sand Stream (Tyranitar, Hippowdon)</li>
                <li>Duration: 5 turns (8 with Smooth Rock)</li>
              </ul>
            </div>

            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Hail/Snow</h3>
              </div>
              <ul>
                <li>Damages non-Ice types (Hail)</li>
                <li>Boosts Ice-type moves by 50% (Snow)</li>
                <li>Common setters: Snow Warning (Abomasnow, Alolan Ninetales)</li>
                <li>Duration: 5 turns (8 with Icy Rock)</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="weather-terrain__section">
          <h2>Terrain Effects</h2>
          
          <div className="weather-terrain__grid">
            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Electric Terrain</h3>
              </div>
              <ul>
                <li>Boosts Electric-type moves by 30%</li>
                <li>Prevents sleep</li>
                <li>Common setters: Electric Surge (Tapu Koko, Pincurchin)</li>
                <li>Duration: 5 turns (8 with Terrain Extender)</li>
              </ul>
            </div>

            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Grassy Terrain</h3>
              </div>
              <ul>
                <li>Boosts Grass-type moves by 30%</li>
                <li>Heals grounded Pokemon by 1/16 HP</li>
                <li>Weakens Earthquake, Magnitude, Bulldoze</li>
                <li>Common setters: Grassy Surge (Rillaboom, Tapu Bulu)</li>
                <li>Duration: 5 turns (8 with Terrain Extender)</li>
              </ul>
            </div>

            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Misty Terrain</h3>
              </div>
              <ul>
                <li>Boosts Dragon-type move resistance</li>
                <li>Prevents status conditions</li>
                <li>Common setters: Misty Surge (Tapu Fini, Weezing-Galar)</li>
                <li>Duration: 5 turns (8 with Terrain Extender)</li>
              </ul>
            </div>

            <div className="weather-terrain__card">
              <div className="weather-terrain__card-header">
                <h3>Psychic Terrain</h3>
              </div>
              <ul>
                <li>Boosts Psychic-type moves by 30%</li>
                <li>Blocks priority moves</li>
                <li>Common setters: Psychic Surge (Tapu Lele, Indeedee)</li>
                <li>Duration: 5 turns (8 with Terrain Extender)</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="weather-terrain__section">
          <h2>Strategic Tips</h2>
          <div className="weather-terrain__tips">
            <ul>
              <li>Weather and terrain effects don't stack - newest one overrides the previous</li>
              <li>Consider team synergy when building around weather/terrain setters</li>
              <li>Watch out for abilities that change or prevent weather (Air Lock, Cloud Nine)</li>
              <li>Use held items to extend duration of beneficial conditions</li>
              <li>Some abilities become stronger in specific weather (Swift Swim in rain, Sand Rush in sandstorm)</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WeatherTerrain; 